module.exports = require('react/lib/ReactFragment').create;


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-create-fragment/index.js
// module id = 691
// module chunks = 0